import joinArray from 'soultrain/lib/array/joinArray'
import fromSpread from 'soultrain/lib/function/fromSpread'
import { pluckObj, values } from 'soultrain/lib/object'

export const getStyles = <O extends object>( styleObject: O ) => <K extends keyof O>( ...items: K[] ): string => values( pluckObj( ...( items as string[] ) )( styleObject ) ).join( ' ' )
export const classes = fromSpread( joinArray( ' ' ) )
